import styled, { createGlobalStyle } from "styled-components";

export const AudioWrapper = styled.div`
  background-color: #1e1e1e;
  border-radius: 10px;
  padding: 14px 16px;
  display: flex;
  align-items: center;
  gap: 12px;
  color: #e0e0e0;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  max-width: 100%;
  box-shadow: 0 2px 6px rgba(0,0,0,0.1);
`;


export const AudioIcon = styled.div`
  font-size: 20px;
  color: #aaa;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const AudioInfo = styled.div`
  flex: 1;
  overflow: hidden;
`;

export const AudioTitle = styled.div`
  font-weight: 500;
  color: #fff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const AudioMeta = styled.div`
  font-size: 12px;
  color: #888;
  margin-top: 2px;
`;

export const AudioProgress = styled.div`
  font-size: 12px;
  border: 1px solid #555;
  border-radius: 50%;
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
`;

export const CustomAudioExtensionStyles = createGlobalStyle`
  .remirror-editor .remirror-audio-wrapper {
    position: relative;
    overflow: visible;
    max-width: 100%;
    margin: 0.5rem 0px;
    border-radius: 8px;
    border: 1px solid white;
    transition: border-color 0.2s ease;
  }

 .remirror-editor .remirror-audio-wrapper:hover {
    outline: 2px solid #f0f0f0!important;
  }

  .remirror-editor .remirror-audio-wrapper.ProseMirror-selectednode {
    outline: 2px solid #6567eb!important;
  }

  /* Estilos para bloquear descarga de audios */
  .remirror-audio-wrapper.download-blocked {
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    pointer-events: auto;
  }

  .remirror-audio-wrapper.download-blocked > div.download-blocked {
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    pointer-events: none;
    -webkit-user-drag: none;
    -khtml-user-drag: none;
    -moz-user-drag: none;
    -o-user-drag: none;
    user-drag: none;
    -webkit-touch-callout: none;
    -webkit-tap-highlight-color: transparent;
  }

  /* Bloquear eventos de mouse para audios protegidos */
  .remirror-audio-wrapper.download-blocked > div.download-blocked:hover {
    cursor: default;
  }

  .remirror-audio-wrapper.download-blocked > div.download-blocked:active {
    cursor: default;
  }

  /* Estilos específicos para modo preview (cuando no es owner) */
  .remirror-preview-container .remirror-audio-wrapper.download-blocked > div.download-blocked {
    pointer-events: none;
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
  }
`